import React from 'react'

import { SiteContext } from 'context/site-context'

import {
  getQS,
  isWebpSupported,
} from 'helpers'

import './index.scss'

const Footer = () => {
  const [ site ] = React.useContext(SiteContext)

  const qs = () => {
    return getQS().trim().length > 0 ? `?${getQS()}` : ''
  }

  return (
    <footer>
      <div className="nav-container">
        <div className="container">
          <div className="nav-bar">
            <a href={`${window.location.origin}/${site.path ? `${site.path}/about` : 'about'}${qs()}`} data-delegate="Footer">About</a>
            <a href={`${window.location.origin}/${site.path ? `${site.path}/privacy` : 'privacy'}${qs()}`} data-delegate="Footer">Privacy Policy</a>
            <a href={`${window.location.origin}/${site.path ? `${site.path}/terms` : 'terms'}${qs()}`} data-delegate="Footer">Terms & Conditions</a>
            <a href="https://www.citysearch.com" data-delegate="Footer" className="citysearch-trigger"><img src={site.logoWhite} alt="CitySearch" /></a>
            <a href="https://www.elocal.com" className="elocal-trigger"><img src="//s3.amazonaws.com/assets.elocal.com/sem/assets/images/logos/elocal-logo-white.svg" alt="eLocal" /></a>
          </div>
          <div className="copyright-container">
            <aside>Copyright &copy; 2004-{new Date().getFullYear()} Insider Pages.  All Rights Reserved.</aside>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
